import { el, setAttr } from 'redom';

import { stringToSVG } from 'utilities';

import OutsideClickEventRegistration from 'lib/outside-click-event-registration';

import linkIconString from 'assets/images/blank-target-link-icon.svg?raw';

import './index.scss';

const linkIcon = stringToSVG(linkIconString);

class LinkURLInputBox {

  constructor(configuration) {

    this.url = configuration.url;
    this.onChange = configuration.onChange;
    this.onClose = configuration.onClose;

    this.input = el('input.text-input', {
      name: 'selected-text-name',
      value: this.url,
      oninput: this.handleInput.bind(this),
      placeholder: 'https://',
      onkeydown: (event) => {
        if (event.key === 'Escape') {
          this.onClose();
        }
      }
    });

    this.link = el('a.link-url', {
      target: '_blank',
      href: this.url
    }, [linkIcon.cloneNode(true)]);

    this.el = el('#link-url-input-box-main', [
      this.input,
      this.link
    ]);

  }

  onmount() {

    this.input.focus();

    this.outsideEventRegistration = new OutsideClickEventRegistration(this.el, this.onClose);

  }

  onunmount() {

    this.outsideEventRegistration.cancel();

  }

  handleInput(event) {
    event.stopPropagation();
    const url = event.target.value;

    setAttr(this.link, {
      href: url
    });

    this.onChange(url);

    if (url === '') {
      this.onClose();
    }

    return false;

  }

}

export default LinkURLInputBox;